import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastTone = 'ok' | 'danger' | 'warn' | 'info'

export interface Toast {
  id: number
  tone: ToastTone
  title: string
  detail?: string
}

/** Transient confirmations and failures, shown in the corner. */
export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])
  let nextId = 1

  function push(tone: ToastTone, title: string, detail?: string): void {
    const id = nextId++
    toasts.value.push({ id, tone, title, detail })
    // Failures stay longer, because they usually need reading.
    const ttl = tone === 'danger' ? 8000 : 4000
    window.setTimeout(() => dismiss(id), ttl)
  }

  function dismiss(id: number): void {
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
  }

  return {
    toasts,
    dismiss,
    success: (title: string, detail?: string) => push('ok', title, detail),
    error: (title: string, detail?: string) => push('danger', title, detail),
    warn: (title: string, detail?: string) => push('warn', title, detail),
    info: (title: string, detail?: string) => push('info', title, detail),
  }
})
